export default class POSService {
  constructor (http, store, router) {
    this.$http = http
    this.$store = store
    this.$router = router
  }

  getPOSes () {
    return new Promise((resolve, reject) => {
      this.$http.get('poses')
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  getPOSesPaginated (params = {}) {
    return new Promise((resolve, reject) => {
      const queryParams = new URLSearchParams()
      if (params.page) queryParams.append('page', params.page)
      if (params.per_page) queryParams.append('per_page', params.per_page)

      this.$http.get(`poses?${queryParams.toString()}`)
        .then(res => res.data)
        .then(data => {
          // Handle Laravel pagination format: { data: [...], pagination: {...} }
          if (data.data && data.pagination) {
            resolve({
              data: data.data,
              total: data.pagination.total || 0,
              current_page: data.pagination.current_page || 1,
              per_page: data.pagination.per_page || 10,
              last_page: data.pagination.last_page || 1,
              from: data.pagination.from || null,
              to: data.pagination.to || null
            })
          } else if (data.data && (data.meta || data.total !== undefined)) {
            // Fallback: Handle other pagination formats (meta object or direct properties)
            resolve({
              data: data.data,
              total: data.meta?.total || data.total || 0,
              current_page: data.meta?.current_page || data.current_page || 1,
              per_page: data.meta?.per_page || data.per_page || 10,
              last_page: data.meta?.last_page || data.last_page || 1
            })
          } else {
            // Fallback to non-paginated response
            resolve({
              data: data.data || data,
              total: Array.isArray(data.data || data) ? (data.data || data).length : 0,
              current_page: 1,
              per_page: params.per_page || 10,
              last_page: 1
            })
          }
        })
        .catch(reject)
    })
  }

  createPOS (data) {
    return new Promise((resolve, reject) => {
      this.$http.post('poses/store', data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  updatePOS (id, data) {
    return new Promise((resolve, reject) => {
      this.$http.post(`poses/update/${id}`, data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  deletePOS (id) {
    return new Promise((resolve, reject) => {
      this.$http.delete(`poses/delete/${id}`)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  changePOSStatus (id) {
    return new Promise((resolve, reject) => {
      this.$http.post(`poses/status/${id}`)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  changeStore (posId, storeId) {
    return new Promise((resolve, reject) => {
      this.$http.post(`poses/${posId}/store/${storeId}`)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }
}
